import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <Logo variant="text-only" className="text-2xl" />
            </div>
            <p className="text-gray-400 mb-4">
              Votre partenaire fiabilité, performance et réactivité 24h/24
            </p>
            <p className="text-sm text-gray-500">
              SARLU au capital de 5 000 000 FCFA<br />
              RCCM : CI-ABJ-03-2025-B13-10106
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('accueil')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('apropos')} className="text-gray-400 hover:text-green-500 transition-colors">
                  À propos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('metiers')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Nos Métiers
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('produits')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Produits & Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Nos Métiers</h3>
            <ul className="space-y-2 text-gray-400">
              <li>BTP & Génie Civil</li>
              <li>Mécanique & Hydraulique</li>
              <li>Location de Matériel</li>
              <li>Maintenance & Réparation</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  147 Rue B5, Cocody Lycée Technique, Abidjan
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-orange-500 flex-shrink-0" />
                <span className="text-gray-400 text-sm">(+225) 07 49 83 29 12</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-gray-400 text-sm">contact@agiplus-group.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} AGIPLUS CI. Tous droits réservés.</p>
          <a 
            href="/admin/login" 
            className="text-gray-500 hover:text-green-400 text-sm mt-3 inline-block transition-colors"
          >
            🔐 Administration
          </a>
        </div>
      </div>
    </footer>
  );
};